var map = {
	"./2023_10_06_TrisaraMainCourse_1080x1080px.jpg": 2131,
	"./Baking Factory Lazimpat-6630.jpg": 5492,
	"./Baking Factory Lazimpat-6636.jpg": 3255,
	"./Grand-Opening.jpg": 6930,
	"./Holi_Land_Trisara-thumbnail-960x480-70.jpg": 2191,
	"./PerosPizza Thamel-6565.jpg": 213,
	"./PerosPizza Thamel-6568.jpg": 594,
	"./Trisara Durbarmarg-6555.jpg": 33,
	"./Trisara Durbarmarg-6556.jpg": 5517,
	"./Trisara-5572.jpg": 4101,
	"./achievements bg.png": 3628,
	"./appetizer.png": 868,
	"./baking factory footer-04.png": 3186,
	"./book_here.png": 6852,
	"./desserts.png": 2643,
	"./drinks.jpg": 5839,
	"./drinks.png": 858,
	"./emptyPlate-01.png": 6987,
	"./emptyPlate.png": 778,
	"./event-1.jpg": 5650,
	"./event-2.jpg": 1777,
	"./event-3.jpg": 2730,
	"./event-4.jpg": 6145,
	"./evolve front desk.jpg": 3110,
	"./gallery-1.jpg": 8475,
	"./gallery-2.jpg": 9298,
	"./gallery-3.jpg": 346,
	"./gallery-4.jpg": 7886,
	"./gallery-5.jpg": 4967,
	"./gallery-6.jpg": 3175,
	"./gallery-7.jpg": 4395,
	"./gallery-8.jpg": 6975,
	"./iloveimg-compressed/Baking Factory Lazimpat-6636-05.jpg": 9081,
	"./iloveimg-compressed/Baking Factory Lazimpat-6636-06.jpg": 1905,
	"./iloveimg-compressed/Baking Factory Lazimpat-6636-08.jpg": 1931,
	"./iloveimg-compressed/Baking Factory Lazimpat-6636-09.jpg": 7645,
	"./iloveimg-compressed/Baking Factory Lazimpat-6636-10.jpg": 3565,
	"./jade room.jpg": 9512,
	"./landing.png": 2014,
	"./live_music.png": 6606,
	"./main-course.png": 9847,
	"./menu-background.png": 3378,
	"./new/Baking Factory Lazimpat-6629.jpg": 9323,
	"./new/IMG_9493.jpg": 1873,
	"./new/IMG_9501.jpg": 5903,
	"./new/Kiki Salad.png": 9722,
	"./new/Korean Wings.png": 8167,
	"./new/Manchow soup.png": 8903,
	"./new/PerosPizza Thamel-6564.jpg": 1356,
	"./new/PerosPizza Thamel-6568.jpg": 580,
	"./new/Trisara Durbarmarg-6547.jpg": 5710,
	"./new/Trisara Durbarmarg-6555.jpg": 1693,
	"./new/Trisara-menu-1.png": 7795,
	"./new/Trisara-menu-2.png": 3593,
	"./new/Trisara-menu-3.png": 4617,
	"./notFound-01.png": 4341,
	"./opening soon-02.png": 7122,
	"./peros-01.png": 5722,
	"./peros.png": 9470,
	"./t-durbarmarg.png": 6835,
	"./t-durbarmarg0.png": 536,
	"./t-img-durbarmarg.jpg": 6383,
	"./t-img-jawalakhel.jpg": 5401,
	"./t-img-lazimpat.jpg": 3112,
	"./t-img-pokhara.jpg": 6984,
	"./t-jawalakhel.png": 9863,
	"./t-jawalakhel0.png": 3806,
	"./t-lazimpat.png": 2515,
	"./t-lazimpat0.png": 8911,
	"./t-mart.png": 4626,
	"./t-pokhara.png": 386,
	"./t-pokhara0.png": 9745,
	"./to-durbarmarg.jpg": 8274,
	"./to-jawalakhel.jpg": 4761,
	"./to-lazimpat.jpg": 6149,
	"./to-pokhara.jpg": 4423,
	"./trainer1.JPG": 495,
	"./trainer2.JPG": 7065,
	"./trisara - baking factory.png": 5287,
	"./trisara family photo.png": 3055,
	"./trisara jade-01.png": 7958,
	"./trisara main.png": 3920,
	"./trisara main1.png": 6947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;